<template lang="pug">
  div
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-dialog(persistent :value='subscriptionDialog' max-width='1000px' transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%; background:#fff;')
        pricing(@close="")
    v-dialog(persistent :value='dialogProfile' max-width='600px' transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        profile-dialog(@close="dialogProfile=false")
    v-navigation-drawer#core-navigation-drawer(v-model="drawer" :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'" :expand-on-hover="expandOnHover" :right="$vuetify.rtl" :src="barImage" mobile-break-point="960" app="" mini-variant-width="80" width="260" v-bind="$attrs")
      template(v-slot:img="props")
        v-img(:gradient="`to bottom, ${barColor}`" v-bind="props")
      v-list-item(two-line="")
        v-list-item-content
          v-list-item-title.text-uppercase.font-weight-regular.display-2
            span.logo-mini {{ $t('td') }}
            span.logo-normal {{ $t('title') }}
      v-divider.mb-1
      v-list(dense="" nav="")
        base-item-group(:item="profile")
        v-divider.mb-2
      v-list(expand="" nav="")
        template(v-for="(item, i) in computedItems")
          base-item-group(v-if="item.children" :key="`group-${i}`" :item="item")
          base-item(v-else-if='user.role!=="Colaborador" || (user.role==="Colaborador" && item.group !== "/dashboard/collaborators")' :key="`item-${i}`" :item="item")
          v-divider.mb-2
</template>

<script>
  import loaders from '@/plugins/mixins/loaders'
  import pricing from '@/views/custom/pricing/Pricing'
  import profileDialog from '@/components/custom/dialogs/profileDialog'
  // import * as firebase from 'firebase'
  // Utilities
  export default {
    name: 'DashboardCoreDrawer',

    components: {
      profileDialog: profileDialog,
      pricing: pricing,
    },

    mixins: [
      loaders,
    ],

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      shopsArr: [],
      collaboratorsList: [],
      snackbar: {
        color: '',
        snackbar: false,
        text: '',
        timeout: 6000,
      },
      bandViewShop: false,
      dialogSubscription: false,
      dialogProfile: false,
      items_sample: [
        {
          icon: 'mdi-view-dashboard',
          title: 'Estadísticas',
          to: '/admin',
        },
        {
          group: '/pages',
          icon: 'mdi-image',
          title: 'pages',
          children: [
            {
              title: 'pricing',
              to: 'pricing',
            },
            {
              title: 'rtl',
              to: 'rtl',
            },
            {
              title: 'timeline',
              to: 'timeline',
            },
            {
              title: 'login',
              to: 'login',
            },
            {
              title: 'register',
              to: 'pricing',
            },
            {
              title: 'lock',
              to: 'lock',
            },
            {
              title: 'user',
              to: 'user',
            },
            {
              title: 'error',
              to: '404',
            },
          ],
        },
        {
          group: '/components',
          icon: 'mdi-view-comfy',
          title: 'components',
          children: [
            {
              title: 'multi',
              group: '',
              children: [
                {
                  title: 'example',
                  href: '#',
                },
              ],
            },
            {
              title: 'buttons',
              to: 'buttons',
            },
            {
              title: 'grid',
              to: 'grid-system',
            },
            {
              title: 'tabs',
              to: 'tabs',
            },
            {
              title: 'notifications',
              to: 'notifications',
            },
            {
              title: 'icons',
              to: 'icons',
            },
            {
              title: 'typography',
              to: 'typography',
            },
          ],
        },
        {
          group: '/forms',
          icon: 'mdi-clipboard-outline',
          title: 'forms',
          children: [
            {
              title: 'rforms',
              to: 'regular',
            },
            {
              title: 'eforms',
              to: 'extended',
            },
            {
              title: 'vforms',
              to: 'validation',
            },
            {
              title: 'wizard',
              to: 'wizard',
            },
          ],
        },
        {
          group: '/tables',
          icon: 'mdi-grid',
          title: 'tables',
          children: [
            {
              title: 'rtables',
              to: 'regular-tables',
            },
            {
              title: 'etables',
              to: 'extended-tables',
            },
            {
              title: 'dtables',
              to: 'data-tables',
            },
          ],
        },
        {
          group: '/maps',
          icon: 'mdi-map-marker',
          title: 'maps',
          children: [
            {
              title: 'google',
              to: 'google-maps',
            },
            {
              title: 'fullscreen',
              to: 'full-screen-map',
            },
          ],
        },
        {
          icon: 'mdi-widgets',
          title: 'widgets',
          to: '/widgets',
        },
        {
          icon: 'mdi-chart-timeline-variant',
          title: 'charts',
          to: '/charts',
        },
        {
          icon: 'mdi-calendar-range',
          title: 'calendar',
          to: '/calendar',
        },
      ],
    }),

    computed: {
      subscriptionDialog () {
        return this.$store.state.subscriptions.subscriptionDialog
      },
      selectedPlan () {
        return this.$store.state.subscriptions.selectedPlan
      },
      barColor () {
        return this.$store.state.drawer.barColor
      },
      barImage () {
        return this.$store.state.drawer.barImage
      },

      user () {
        return this.$store.state.users.user
      },

      shops () {
        // console.log(this.$store.getters['shops/getItems'])
        return this.$store.getters['shops/getItems']
      },

      shopsList () {
        // console.log(this.shops)
        const children = []
        if (this.shops) {
          this.shops.forEach(element => {
            // console.log(element.name, element.id)
            children.push({ title: element.name, to: element.id })
          })
          return children
        } else {
          return children
        }
      },
      shopsNav () {
        return [
          {
            icon: 'mdi-plus',
            title: 'Crear tienda',
            to: '/dashboard/create-shop',
          },
          {
            group: '/dashboard/shops',
            icon: 'mdi-home',
            title: 'Mis tiendas',
            children: [...this.shopsList],
          },
        ]
      },
      items () {
        return [
          {
            group: '/referals/clients',
            icon: 'mdi-card-account-phone',
            title: 'Mi lista de referidos',
            to: '/referals/referralsInfo',
          },
          {
            group: '/referals/providers',
            icon: 'mdi-card-account-phone',
            title: 'Historial de retiros',
            to: '/referals/Withdraw',
          },
          {
            group: '/dashboard/',
            icon: 'mdi-domain',
            title: 'Portal Empresas',
            to: '/dashboard/',
          },
        ]
      },

      drawer: {
        get () {
          return this.$store.state.drawer.drawer
        },
        set (val) {
          // console.log(val, this)
          this.$store.dispatch('drawer/set_drawer', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          group: '',
          // title: this.$t('avatar'),
          title: this.$store.state.users.user.email,
          children: [
            {
              title: this.$t('my-profile'),
              to: 'dashboard/profile',
            },
            /* {
              title: this.$t('edit-profile'),
              to: 'collaborators',
            },
            {
              title: this.$t('settings'),
              to: 'collaborators',
            }, */
          ],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },

    created () {
      const vm = this
      this.getDtaRestrictions()
      vm.getProfile()
      vm.loadLocations()
    },
    mounted () {
      setTimeout(() => {
        this.$store.dispatch('users/getCollaborators').then(res => {
          this.collaboratorsList = res
          this.shopsArr = this.$store.getters['shops/getItems']
          const data = {
            shops: this.shopsArr,
            collaborators: this.collaboratorsList,
          }
          this.$store.dispatch('payment/getSubscriptionData', data)
        })
      }, 1000)
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
      validateProfile (profile) {
        const vm = this
        // console.log(profile)
        if (!profile || !profile.name || !profile.last_name || !profile.phone) {
          vm.dialogProfile = true
          // console.log(profile)
        }
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      getDtaRestrictions () {
        // firebase.database().ref(`users/${this.user.uid}/shops`).on('value', (snapshot) => {
        //   const res = snapshot.val()
        //   let totalShops = 0
        //   if (res != null) {
        //     const arr = Object.keys(res).map(card => {
        //       return { id: card, data: res[card] }
        //     })
        //     totalShops = arr.length
        //   }
        //   this.$store.dispatch('users/getRestrictions').then(res => {
        //     // console.log(res)
        //     const salePointRestriction = res.salePoints
        //     if (salePointRestriction > totalShops) {
        //       this.bandViewShop = true
        //     } else {
        //       this.bandViewShop = false
        //     }
        //   }, rej => {
        //     this.setDataNotification(true, 'error', this.$t('shop.createModule.errorGetRestriction'))
        //   })
        // }, (error) => {
        //   // console.log(error)
        //   this.setDataNotification(true, 'error', this.$t('shop.createModule.errorGetRestriction'))
        // })
      },
      getProfile () {
        const vm = this
        const profilData = vm.$store.state.users.profile
        // console.log(profilData)
        if (profilData) {
          vm.validateProfile(profilData)
        } else {
          vm.$store.dispatch('users/loadProfile').then(function (res) {
            vm.validateProfile(res)
          })
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'
  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
